import React from 'react';
import {Image, Modal} from 'antd';

const CustomerModal = (props) => {
  const {updateModalVisible, onCancel} = props;

  return (
    <Modal title={'联系客服'}
           destroyOnClose={true}
           maskClosable={false}
           open={updateModalVisible}
           onCancel={onCancel}
           footer={false}
    >
      <Image src={'https://website-1306430916.cos.ap-shanghai.myqcloud.com/website/kfewm.png'} preview={false}/>
    </Modal>
  );
};

export default CustomerModal;
